import DatabaseModel from './DatabaseModel.js';

var AiContextPromptRules = Object.create(DatabaseModel);

AiContextPromptRules.model = 'ai/agent/context/prompt-rules';
AiContextPromptRules.modelFront = 'ai/agent/context/prompt-rules';

export default AiContextPromptRules;
